/**
 * 异常上报管理器
 */
export default class Raven {
  /**
   * 捕获异常
   * @param {Error} error - 异常对象, 如: new Error()
   * @param {'info' | 'warning' | 'error'} [level = 'error'] - 异常登记
   * @param {*} extra - 额外信息
   */
  static captureException(error, { level = 'error', extra } = {}) {
    if (window.Raven) {
      window.Raven['captureException'](error, { level, extra });
    }
  }
}
